import React from "react";

type Props = {
  value: string[];
  onChange: (value: string[]) => void;
  options: Record<string, string>; // value -> label mapping
  disabled?: boolean;
};

export const MultiSelectField: React.FC<Props> = ({
  value,
  onChange,
  options,
  disabled,
}) => {
  const selectedValues = Array.isArray(value) ? value : [];

  const handleToggle = (optionValue: string): void => {
    if (selectedValues.includes(optionValue)) {
      onChange(selectedValues.filter((v) => v !== optionValue));
    } else {
      onChange([...selectedValues, optionValue]);
    }
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      {Object.entries(options).map(([optionValue, optionLabel]) => {
        const isChecked = selectedValues.includes(optionValue);
        return (
          <label
            key={optionValue}
            className={`tw-flex tw-items-center tw-gap-2 ${
              disabled ? "tw-cursor-not-allowed" : "tw-cursor-pointer"
            }`}
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleToggle(optionValue)}
              disabled={disabled}
              className="tw-form-checkbox tw-h-4 tw-w-4 tw-rounded
                tw-border-gray-400 tw-text-blue-600
                focus:tw-ring-2 focus:tw-ring-blue-500
                disabled:tw-border-gray-200 disabled:tw-text-gray-200 disabled:tw-cursor-not-allowed"
            />
            <span
              className={`tw-text-sm ${
                disabled ? "tw-text-gray-500" : "tw-text-gray-700"
              }`}
            >
              {optionLabel}
            </span>
          </label>
        );
      })}
    </div>
  );
};
